import { render, staticRenderFns } from "./vesselVoy.vue?vue&type=template&id=824dc85e&"
import script from "./vesselVoy.vue?vue&type=script&lang=js&"
export * from "./vesselVoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports